// extracted by mini-css-extract-plugin
export default {"field":"RichTextEditorField_field__ejGoL","label":"RichTextEditorField_label__vrayX","error":"RichTextEditorField_error__RbDT5","borderless":"RichTextEditorField_borderless__o-hT9"};